// extracted by mini-css-extract-plugin
export var orderSummary = "_t5-0";
export var showMoreLessButton = "_t5-1";